import apiClient from './client';
import type {
  Workspace,
  CreateWorkspacePayload,
  UpdateWorkspacePayload,
  WorkspaceMember,
  InviteMemberPayload,
} from '@/types/workspace.types';

export const workspacesApi = {
  list: async (): Promise<Workspace[]> => {
    const { data } = await apiClient.get<Workspace[]>('/workspaces');
    return data;
  },

  getById: async (id: string): Promise<Workspace> => {
    const { data } = await apiClient.get<Workspace>(`/workspaces/${id}`);
    return data;
  },

  create: async (payload: CreateWorkspacePayload): Promise<Workspace> => {
    const { data } = await apiClient.post<Workspace>('/workspaces', payload);
    return data;
  },

  update: async (id: string, payload: UpdateWorkspacePayload): Promise<Workspace> => {
    const { data } = await apiClient.patch<Workspace>(`/workspaces/${id}`, payload);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/workspaces/${id}`);
  },

  getMembers: async (workspaceId: string): Promise<WorkspaceMember[]> => {
    const { data } = await apiClient.get<WorkspaceMember[]>(
      `/workspaces/${workspaceId}/members`,
    );
    return data;
  },

  inviteMember: async (
    workspaceId: string,
    payload: InviteMemberPayload,
  ): Promise<WorkspaceMember> => {
    const { data } = await apiClient.post<WorkspaceMember>(
      `/workspaces/${workspaceId}/members`,
      payload,
    );
    return data;
  },

  removeMember: async (workspaceId: string, userId: string): Promise<void> => {
    await apiClient.delete(`/workspaces/${workspaceId}/members/${userId}`);
  },
};

export default workspacesApi;
